import styled from 'styled-components';

export const HelpWrapper = styled.div`
	position: relative;
	display: inline-block;
	& .tooltip-wrap {
		box-shadow: 0 1px 7px 0 rgb(0 0 0 / 20%);
	}
	&:hover .tooltip-wrap{
		display: block
	}
`;

export const LinkHelpList = styled.a`
  display: block;
	&.helpList {
		border-bottom: none;
  	color: #008cff;
	}
  border-top: 1px solid #e6e6e6;
  padding: 5px 0;
	margin-bottom: 3px;
`;
